var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.magicitem.basePrice != ""
        ? [
            _vm._v(
              "\n    Grundpreis: " + _vm._s(_vm.magicitem.basePrice) + "\n  "
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }